<template>
    <div class="rounded-xl border border-gray-200 bg-white px-5 py-4">
        <p
            class="mb-3 text-xs font-semibold uppercase tracking-widest text-gray-400"
        >
            {{ t("vue.kiosk_da_summary_title") }}
        </p>
        <div class="flex flex-wrap gap-x-6 gap-y-2">
            <div
                v-for="item in daySummaryItems"
                :key="item.label"
                class="flex items-center gap-2"
            >
                <span
                    class="inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded"
                    :class="item.bgClass"
                >
                    <component :is="item.icon" class="h-3 w-3 text-white" />
                </span>
                <span
                    class="text-sm font-bold"
                    :class="item.count > 0 ? 'text-gray-900' : 'text-gray-400'"
                >
                    {{ item.count }}
                </span>
                <span class="text-sm text-gray-500">{{ item.label }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import {
    UserPlusIcon,
    CheckBadgeIcon,
    UserGroupIcon,
    CreditCardIcon,
    ClockIcon,
    ArrowPathIcon,
    CurrencyDollarIcon,
} from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";
import type { ISummary } from "../types";

const { t } = useTranslations();

const props = defineProps<{
    summary: ISummary;
}>();

const daySummaryItems = computed(() => [
    {
        label: t("vue.kiosk_da_new_registrations"),
        count: props.summary.new_users,
        icon: UserPlusIcon,
        bgClass: "bg-blue-500",
    },
    {
        label: t("vue.kiosk_da_email_verifications"),
        count: props.summary.verified_emails,
        icon: CheckBadgeIcon,
        bgClass: "bg-green-500",
    },
    {
        label: t("vue.kiosk_da_new_teams"),
        count: props.summary.new_teams,
        icon: UserGroupIcon,
        bgClass: "bg-purple-500",
    },
    {
        label: t("vue.kiosk_da_new_free_plans"),
        count: props.summary.new_free_plans,
        icon: CreditCardIcon,
        bgClass: "bg-orange-500",
    },
    {
        label: t("vue.kiosk_da_free_plan_restarts"),
        count: props.summary.free_plan_restarts,
        icon: ArrowPathIcon,
        bgClass: "bg-amber-500",
    },
    {
        label: t("vue.kiosk_da_new_subscriptions"),
        count: props.summary.new_subscriptions,
        icon: CurrencyDollarIcon,
        bgClass: "bg-emerald-600",
    },
    {
        label: t("vue.kiosk_da_ending_trials"),
        count: props.summary.ending_trials,
        icon: ClockIcon,
        bgClass: "bg-red-500",
    },
]);
</script>
